module.exports = __webpack_public_path__ + "img/perforaciones2_4-3.8ef846e2.webp";